import styled from 'styled-components'
import { Link } from 'react-router-dom'
import WhiteContainer from 'views/components/common/WhiteContainer'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-content: center;
`

export const TitleInventoryState = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #c6016b;
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 18px;
`

export const LitleCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 50px 0 10px 0;
`

export const InventoryStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
`

export const LittleCard = styled(WhiteContainer)`
  gap: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #919eab;

  &:hover {
    transform: scale(1.05);
    transition: ease-in-out 0.3s;
  }
`

interface ITextLitleCard {
  color?: string
}

export const TextLitleCard = styled.span<ITextLitleCard>`
  font-size: 14px;
  font-weight: 700;
  color: ${(props: ITextLitleCard) => props.color || '#1F2124'};
`

export const CountTestAvailables = styled.span`
  font-weight: 700;
  font-size: 32px;
  color: #2d749c;
  text-align: 'center';
  margin: 4px 0px;
`

export const BigCard = styled(WhiteContainer)`
  display: flex;
  width: 100%;
  padding: 16px;
  width: 31.5%;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  min-height: 280px;
  max-height: 450px;
  height: 100%;
`

export const MyProcessContainer = styled(WhiteContainer)`
  grid-column: 1 / -1;
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  max-height: none;
  margin-bottom: 24px;
`

export const BigContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
  width: 100%;
  margin-top: 16px;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const MetricsGrid = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const MetricCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  width: auto;
  height: 112px;
  gap: 14px;
  padding: 18px 20px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);
`

export const MetricIcon = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  border-radius: 50%;
  background: ${(props) => `${props.color}18`};
  color: ${(props) => props.color};
  font-size: 28px;
  font-weight: 700;
`

export const MetricLabel = styled.span`
  display: block;
  color: #536b84;
  font-size: 14px;
  font-weight: 600;
`

export const MetricValue = styled.strong`
  display: block;
  margin-top: 4px;
  color: #1f344d;
  font-size: 32px;
  line-height: 1;
`

export const AnalyticsCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: auto;
  min-height: 370px;
  min-width: 0;
  padding: 22px 26px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);
`

export const AnalyticsCardTitle = styled.h3`
  margin: 0;
  color: #1f344d;
  font-size: 22px;
  font-weight: 800;
`

export const AnalyticsCardSubtitle = styled.p`
  margin: 8px 0 24px;
  color: #71859d;
  font-size: 14px;
`

export const BarsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const BarRow = styled.div`
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 110px minmax(0, 1fr) 28px;
  }
`

export const BarLabel = styled.span`
  color: #1f344d;
  font-size: 15px;
`

export const BarTrack = styled.div`
  display: block;
  width: 100%;
  min-width: 0;
  height: 14px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf2f6;
`

export const BarFill = styled.div<{ $color: string; $width: string }>`
  display: block;
  height: 100%;
  width: ${(props) => props.$width};
  border-radius: inherit;
  background: ${(props) => props.$color};
`

export const BarValue = styled.strong`
  color: #1f344d;
  text-align: right;
`

export const ProgressValue = styled.strong`
  display: block;
  color: #2d749c;
  font-size: 56px;
  line-height: 1;
`

export const ProgressCaption = styled.p`
  margin: 10px 0 22px;
  color: #536b84;
  font-size: 16px;
`

export const ProgressTrack = styled.div`
  display: block;
  width: 100%;
  height: 16px;
  overflow: hidden;
  border-radius: 999px;
  background: #e6edf2;
`

export const ProgressFill = styled.div<{ $width: string }>`
  display: block;
  width: ${(props) => props.$width};
  height: 100%;
  border-radius: inherit;
  background: #2bc48a;
`

export const ProgressLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #536b84;
  font-size: 15px;

  strong {
    margin-left: auto;
    color: #1f344d;
  }
`

export const LegendDot = styled.span<{ color: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${(props) => props.color};
`

// items processes

export const ItemProcessContainer = styled.div`
  width: 100%;
  font-family: 'Public Sans', sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const TextItalicProcess = styled.p`
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-style: italic;
  font-weight: 400;
  color: #707070;
`

export const TextEdit = styled.p`
  color: #2d749c;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Public Sans', sans-serif;
  cursor: pointer;
  margin-left: 10px;
`

interface IBadge {
  bgColor?: string
}

export const Badge = styled.div<IBadge>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Public Sans', sans-serif;
  font-size: 12px;
  background-color: ${(props: IBadge) => props.bgColor || '#60CC1E'};
  color: #ffffff;
  height: 16px;
  border-radius: 20px;
  padding: 6px 10px;
`

interface IRow {
  width?: string
  margin?: string
}

export const Row = styled.div`
  width: ${(props: IRow) => props.width || '100%'};
  margin: ${(props: IRow) => props.margin || '0'};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 2;
  height: 100%;
`

export const MyProcessBottomContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`

export const MyProcessList = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const ProcessTable = styled.div`
  width: 100%;
  min-width: 1080px;
`

export const ProcessTableHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) minmax(150px, 1fr) 110px minmax(260px, 1.5fr);
  gap: 16px;
  align-items: center;
  padding: 12px 20px;
  color: #163247;
  background: #eff5fb;
  border-radius: 10px;
  font-family: 'Public Sans', sans-serif;
  font-size: 15px;
  font-weight: 700 !important;
  letter-spacing: 0.01em;

  strong {
    font-weight: 800 !important;
  }
`

export const ProcessTableRow = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) minmax(150px, 1fr) 110px minmax(260px, 1.5fr);
  gap: 16px;
  min-height: 44px;
  align-items: center;
  padding: 4px 20px;
  color: #1f344d;
  border-bottom: 1px solid #e5edf4;

  &:last-child {
    border-bottom: 0;
  }
`

export const ProcessName = styled.span`
  font-size: 15px;
  font-weight: 400;
`

export const ProcessType = styled.span`
  color: #536b84;
  font-size: 14px;
`

export const ProcessDate = styled.span`
  color: #536b84;
  font-size: 14px;
`

export const ProcessActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2d749c;
  font-size: 14px;
  font-weight: 700;

  svg {
    flex: 0 0 auto;
  }
`

export const ProcessActionText = styled.button`
  padding: 0;
  color: inherit;
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  text-align: left;
`

export const ProcessStatus = styled.span<{ color: string; background: string }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  min-width: 82px;
  padding: 7px 12px;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
`

export const BannerContainer = styled(WhiteContainer)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
  border: 1px solid #f0c36d;
  background: linear-gradient(180deg, #fffaf0 0%, #fff4dc 100%);
`

export const BannerTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #6b4f00;
`

export const BannerMessage = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #4e3d08;
`

export const BannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`

export const InventoryListContainer = styled(WhiteContainer)`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 12px;
  margin-top: 24px;
`

export const InventoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`

export const CompanyLogo = styled.img`
  width: 96px;
  height: 80px;
  object-fit: contain;
  flex: 0 0 96px;
`

export const CompanyBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`

export const CompanyName = styled.span`
  color: #163247;
  font-size: 20px;
  font-weight: 700;
`

export const InventoryAction = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #2d749c;
  border-radius: 4px;
  color: #2d749c;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background-color: #f2f8fb;
  }
`

export const InventoryTableHeader = styled.div`
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: minmax(130px, 1.2fr) minmax(150px, 1fr) minmax(130px, 1fr) minmax(150px, 1.1fr) minmax(220px, 1.8fr) minmax(120px, auto);
  gap: 16px;
  padding: 16px 20px;
  background: #eff5fb;
  border: 0;
  border-radius: 12px;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 15px;
  font-weight: 700 !important;
  letter-spacing: 0.01em;
  line-height: 1.2;

  strong {
    font-weight: 800 !important;
  }

  @media (max-width: 760px) {
    display: none;
  }
`

export const InventoryList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;
`

export const InventoryItem = styled.div`
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: minmax(130px, 1.2fr) minmax(150px, 1fr) minmax(130px, 1fr) minmax(150px, 1.1fr) minmax(220px, 1.8fr) minmax(120px, auto);
  gap: 16px;
  align-items: center;
  min-height: 78px;
  padding: 16px 20px;
  color: #536b84;
  border-top: 1px solid #e5e7eb;

  > * {
    min-width: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`

export const InventoryItemLabel = styled.span`
  color: #1f344d;
  font-size: 15px;
  font-weight: 400;
`

export const InventoryItemValue = styled.span`
  color: #536b84;
  font-size: 14px;
`

export const InventoryWarning = styled.span`
  grid-column: 1 / -1;
  padding: 8px 12px;
  border-left: 3px solid #c6016b;
  background-color: #fff4f8;
  color: #8b124f;
  font-size: 14px;

  @media (max-width: 760px) {
    grid-column: 1;
  }
`

export const InventoryNotification = styled.span<{ warning?: boolean }>`
  display: block;
  padding: ${(props) => (props.warning ? '8px 12px' : '0')};
  border-left: ${(props) => (props.warning ? '3px solid #c6016b' : '0')};
  background-color: ${(props) => (props.warning ? '#fff4f8' : 'transparent')};
  color: ${(props) => (props.warning ? '#8b124f' : '#71859d')};
  font-size: 14px;
  line-height: 1.35;
`
